// Add to this list to define new actions.
const ACTION_TYPES= [
	// Comment below each action name explains what the action does and/or what
	// other keys the action should have.

	//
	// Misc top-level actions
	//
	"INITIAL",
	// Action sent on page load to let the updater initialize state.
	// State is only set if server side loaded
	// - pageState: the initial value of the page object.
	// - state: the server-sent state
	// - isServerSide: server-side rendered

	"FINAL",
	// Action sent when leaving the page to make sure anything unsaved gets saved.

	"START_IDLE_OR_BLUR",
	// Action sent when the user becomes inactive on the page or browser is
	// minimized / tab is switched.
	// - isIdle: boolean

	"END_IDLE_OR_BLUR",
	// Action sent when the tab is reselected, or the browser unminimized, or
	// the user becomes active again on the page.

	"NOTIFY_SLEEP",
	// Action sent when the IdleSleep notices a setTimeout occurred outside of
	// the expected window implying that the browser was likely idle in an
	// undetected way (like a lid-closing sleep)

	"UPDATE_TIMERS",
	// Action sent periodically when no actions have been dispatched for awhile.
	// Noop, but runs the post-update timers.

	"STORAGE_UPDATED",
	//Action sent when local storage for the page is updated
	// - event: the StorageEvent from the change

	"SET_PAGE",
	// - pageState: The new page state. Will completely replace the old one.

	"SET_PAGE_VIDEO_INDEX",
	// - videoIndex

	"SET_TOKEN",
	// - token: The new token.
	// - tokenExpiration: The new token expiration.

	"SET_USER_ID",
	// - userID

	"SET_CONNECTED",
	// - connected: bool

	"SET_BAD_BROWSER",
	// Action sent if the browser lacks required features (WebSockets, flexbox).

	"SET_NO_COOKIES",
	// Action sent if there are no cookies available,

	"CHECK_BROWSER",
	// Action initiated once the global modal is mounted to check if the user's browser is compatible
	// and if a message needs to be shown informing them of that fact

	"DEVICE_ROTATE",
	// Basically just forces an action so the postupdate screen size check can happen.
	"IGNORE_SCREEN_WARNING",
	// Allow playing on trainer even if on phone.

	"SHOW_MESSAGE",
	"SHOW_CONFIRM",
	// Action that shows some arbitrary global message.
	// - messageType: one of "disconnected", ...
	// - data: optional object with any data the message modal might need to
	//   display itself.

	"SHOW_PROBLEM_SLIDER",
	// Action that shows arbitrary slider message on problem page.
	// - data: {message: the text copy of the slider}

	"CONFIRM_RESET_PROBLEM",

	"CONFIRM_PAGE_NAVIGATION",
	// - href: page user is trying to navigate to
	// - confirmType: one of "leaveResult", ...
	// - data: optional object with any data the confirmation modal might need to
	//   display itself.

	"UPDATE_SHOW_HELP",
	// Sets a flag on user model to not show the initial help blurb on the top
	// bar.

	"UPDATE_TUTORIAL_STEP",
	// - tutorialType: string
	// - step: string, step tutorial is on

	"UPDATE_USER_EVENTS_TRIGGERED",
	// - pathArray: path within eventsTriggered JSON column on user table row
	// - propValue: value to set at that path

	"UPDATE_SHOW_NOTIFICATION",
	// Sets a flag on page model for whether any notifications are being shown
	// i.e. levelupmodal and beastbuilder notification
	// - isShowingNotification: bool

	//
	// Registration and Login Actions
	//

	"AUTHENTICATION_SUCCESS",
	// -userID (the authenticated user's id)
	"AUTHENTICATION_FAIL",
	// -error

	// See startReact.js. Dispatched after a random delay on vault init.
	"VERSION_CHECK_WAITED",

	//frontend/backend version check handler
	"VERSION_CHECK",
	// - backendVersion - client version from backend package.json
	// - frontendVersion - client version from frontend package.json

	"SESSION_EXPIRED",
	//Gets sent when an endpoint 401s so the user's session has expired

	"SESSION_NOT_PLAYING",
	//Gets sent when an endpoint throws E_SESSION_NOT_PLAYING

	"UPDATE_LOGIN_USERNAME", //for remembering username from going from login to reset password page
	// -username (optional)

	"UPDATE_AVATAR_DATA",
	// - user model's avatar.avatarImageData gets updated, frontend action only.

	"OPEN_SETTINGS_MODAL",

	"OPEN_LEADERBOARDS_MODAL",
	"CLOSE_LEADERBOARDS_MODAL",

	"UPDATE_USER_SETTINGS",
	"UPDATE_TEMP_USER_SETTINGS",
	// - can be used to update settings
	// - takes in setting fields

	"REPORT_BUG",
	// show bug report modal

	"UPDATE_BUG_SUBMITTING",
	// - update whether or not the user is currently submitting a bug

	//
	// API actions
	//

	// Most of these are in apiActionTypes now.

	"LOAD_CHAPTER_ANTICIPATED_REQUEST",
	// Pass userID and chapterID as usual. Used for when chapter is not shown but
	// it might be navigated to soon.

	"PLAY_DEMO_BLOCK",
	// Pass blockID. Used to load the block data into tempUser object in state.

	"LOAD_DEMO_CHAPTER",
	// Pass chapterID. Used to load chapter and block data into tempUser object in state.
	"LOAD_DEMO_CHAPTERS",
	// No parameters. Used to load all the demo chapters and block data for the demo classroom page.

	"LOAD_SHARED_DEMO_PROBLEMS",
	// blockID: the block ID being played/loaded
	// isTrophy: if the block ID is for a trophy problem

	"CLOSE_DEMO_TUTORIAL",
	"RESTART_DEMO",
	"EXIT_DEMO_TUTORIAL",
	"SHOW_DEMO_EMAIL_SIGN_UP_MODAL",
	"CLOSE_DEMO_EMAIL_SIGN_UP_MODAL",
	"DEMO_SLIDER_OPENED",
	"ATTEMPT_REPLAY_DEMO_LESSON",
	"REPLAY_DEMO_BLOCK",
	"VIEW_VIDEO_UNDER_CONSTRUCTION",
	"OPEN_DEMO_LEARN_MORE_MODAL",
	"CLOSE_SEQUENCE_SLIDEOUT",
	// No parameters

	//
	// Library actions
	//

	"LOAD_DEMO_LIBRARY_CHAPTERS",
	// No parameters

	"LOAD_LIBRARY_CHAPTERS_ANTICIPATED_REQUEST",
	// Pass userID and list of chapterIDs.
	// Used for loading adjacent grade pages on library.

	"SET_VIEWED_LIBRARY_PAGE",
	// chapterID: number,
	// lastVisitedPage: number

	"UPDATE_PAGES_READ",
	// chapterID: number,
	// pageJustRead: number

	"UPDATE_SECTIONS_MARKED_DONE",
	// chapterID: number,
	// sectionID: number

	//
	// Problem playing actions
	//

	"TRAINER_INITIAL",
	// Dispatched as soon as trainer bundle loads

	"RETRY_UPDATE_RESULT",
	// - resultID
	// - resultSource

	"MARK_CHAPTER_COMPLETE_CELEBRATION_SEEN",
	// Sets hasSeenChapterCompleteCelebration on the current chapter-test result and saves.

	"SUBMIT_TRIAL",
	// - customState: Optional, custom state to save to problem before submitting.
	// - currentTrialAns: answer to submit.
	// - botTrials: bot trials to also send through processor for tests.
	// - forceSubmit: true to ignore processor not allowing submissions.
	// - giveUp: if trial is giving up, this is a Date.now return
	// - isDebugSubmission: true if this is a debug submission
	// - forceIsCorrect: only applies with isDebugSubmission true, sets the isCorrect value (if it should be forced)

	"SUBMIT_TEST",
	// Submit problems in test block.
	// - isDebugSubmission: true if this is a debug completion of the test
	// - numStars: only applies with isDebugSubmission true, the number of stars the user should

	"START_TEST",
	// Moves user to test block page and sets flag that test is starting (used to prevent new test starting on refresh)

	"START_BOOK_TEST",
	// Moves user to test block page (used as part of a confirm modal)

	"START_TEST_PART_2",
	// Moves the user to next problem in the test

	"SKIP_TEST_PART_2",
	// Stops the test after finishing part 1, before proceeding to part 2

	"SWITCH_TO_TEST_PART",
	// Allows teachers to force switching to given test part

	"VIEW_TEST_HISTORY",

	"SAVE_TEST_ANSWER",
	// Applied to current result
	// Marks problem as saved
	// - customState: Optional, custom state to save to problem before submitting.
	// - currentTrialAns: answer to submit.
	// - isDebugSubmission: true if this is a debug save
	// - forceIsCorrect: only applies with isDebugSubmission true, sets the isCorrect value

	"SAVE_TRIAL_STATE",
	// Applied to current result
	// - customState: Custom state.
	// - checkIfComplete: (optional) true
	// - needsUpdate: (optional) true if after saving, the vault should emit a trialStateUpdate and cause any views using this state to update their state

	"CHANGE_TRIAL_STATE",
	// Applied to current result
	// - changeType: "reset", "undo", or "redo"

	"REPLAY_BLOCK",
	// - blockID: Block to replay.

	"REPLAY_PROBLEM",
	// Applied to current result
	// Unfinishes problem with latest customState

	"LOAD_NEXT_BLOCK",
	// - blockID: block to load

	"LOAD_NEXT_BLOCK_AND_VIDEO",
	// - blockID: block to load

	"REVIEW_QUIT_CHOICE",
	//Applies to current review result
	// - willQuit: boolean indicating their choice to quit or continue

	"NEXT_PROBLEM",
	"PREVIOUS_PROBLEM",
	"GOTO_FIRST_PROBLEM",
	"GOTO_LAST_PROBLEM",
	// Applied to current result

	"GOTO_FINAL",
	// Applied to current result

	//Used by SequenceRow and BAClassAssignment when a test is clicked on
	"GOTO_TEST",

	"SAVE_INSTRUCTIONS_STATE",
	//Applied to current result
	// - customState: Custom state.

	"SET_SHOW_INSTRUCTIONS",
	// Applied to page
	// - showInstructions: Boolean to set in the page

	"ACKNOWLEDGE_INSTRUCTIONS_REVIEW",
	// Acknowledges the user has clicked the Review Instructions button after having
	// instructions pop up because they are doing poorly

	"SET_SHOW_BOOK",
	// Applied to page
	// - showBook: Boolean to set in the page

	"SET_SHOW_VIDEO",
	// Applied to page
	// - showVideo: Boolean to set in the page

	"CLEAR_VIDEO_INTERVENTION",
	// Clears videoInteraction on page state
	// Also emits vault event to close slider

	"SET_SHOW_THEATER_LESSON_MODAL",
	// Applied to page
	// - showTheaterToLessonModal: Boolean to set in the page

	"REQUEST_SPECIFIC_SET",
	//Requires one of the two following things:
	// - setNumber: 1-n where n is the number of sets in the block's setList;
	//              to request a specific set from the current block
	// - originalSetID: the original id of the set that you want to request a new version of
	//          (may pop you to the most updated version of that set)
	// - forceNewResult (opt): boolean indicating if a new result should be started even if there's one
	//                         already for that set
	// - forceResume (opt): boolean indicating if a result should be resumed, if possible

	"SET_DEV_PROBLEM",
	// - problemData: The problem model to try out.

	"SET_ENGINE_TESTER_PROBLEM",
	// - problemData: The problem model to try out.

	//
	// Read Aloud Actions
	//
	"READ_ALOUD",
	"UPDATE_READ_ALOUD_STATUS",

	//
	// Tutorial Page Actions
	//
	"STUDENT_TUTORIAL_SET_STEP",
	"STUDENT_TUTORIAL_SET_PART",
	"STUDENT_TUTORIAL_SET_PROBLEM",
	"TUTORIAL_BUNDLE_INITIAL",
	"STUDENT_TUTORIAL_SET_SHOW_TUTORIAL_MODAL",
	"STUDENT_TUTORIAL_SET_SHOW_EGBERTA_MODAL",
	"STUDENT_TUTORIAL_SET_CURRENT_PROBLEM_INDEX",
	"STUDENT_TUTORIAL_MARK_PROBLEM_WORKED_ON",
	"STUDENT_TUTORIAL_FINISH_AND_GO_TO_URL",
	"STUDENT_TUTORIAL_SHOW_GET_STARTED_ORANGE_ARROW",

	// needed for showing the orange arrow in the instructions modal
	"INSTRUCTIONS_PROBLEM_CORRECT",

	//
	// Office Page Actions
	//

	"OFFICE_INITIAL",
	// Dispatched as soon as office bundle loads

	"SUPPRESS_OFFICE_CONFIRM_MODAL",
	// Suppresses the confirm modal for locking items if "do not show again" option is selected

	"START_OFFICE_LOGIN",
	// Dispatched by buttons, emits an event that opens the office login modal
	"START_CHANGE_PASSWORD",
	// Dispatched by buttons, emits an event that opens the change password modal
	"START_CHANGE_EMAIL",
	// Dispatched by buttons, emits an event that opens the change email modal
	"START_SWITCH_ACCOUNT",
	// emits an event that opens the office switch account modal

	"ADD_BOOKS_TO_CART",
	// - additions: an array of objects with the following keys:
	//    - type: guide, practice, guide-practice, or grade-set (required)
	//    - quantity: a number (required)
	//    - bookHash: the hash for the books (required for all types but grade-set)
	//    - grade: the grade of the set (required for type grade-set)

	"ADD_SUBSCRIPTIONS_TO_CART",
	// - additions: an array of objects with the following keys:
	//    - type: monthly, yearly, or bundle (required)
	//    - name, (required)
	//    - grade: grade level, (required for bundles)

	"REMOVE_SUBSCRIPTIONS_FROM_CART",
	// Removes all subscriptions from cart.

	"ADD_ITEM_TO_CART",
	// - sku, the sku of the item
	// - quantity, the number to add to the cart,
	// - options, an optional object with any options selected applying to the item (like {size: "large", color: "blue"})

	"REMOVE_ITEM_FROM_CART",
	"REMOVE_SET_FROM_CART",
	// - item, the item from the cart items list

	"CONVERT_BUNDLE",
	// Converts specific items to bundles
	// - subscription name (name of student)
	// - bundle ID (sku)

	"CONVERT_SUGGESTED_BUNDLE",
	// Converts suggested items to bundles (adds more books)

	"UPDATE_CART_ITEM_OPTIONS",
	// - item, the item from the cart items list
	// - field, "name"

	"UPDATE_CART_ITEM_SKU",
	// - cartItem, the item from the cart items list
	// - newSku, the new SKU to set on the item

	"SWAP_BUNDLE_GRADE",
	// - bundleItem, the collapsed bundle item from getItemsWithBundles
	// - newBundleID, the target bundle ID (e.g. "bundle-grade-4")

	"UPDATE_CART_ITEM_QUANTITY",
	// - item, the item from the cart items list
	// - quantity, the new quantity that that item should have

	"UPDATE_CART_FORMDATA",
	// - section: one of ["shipping", "billing", "contact"].
	// - vals: object mapping changed fields to their new values.

	"UPDATE_DEFAULT_CART_SUBSCRIBE_EMAIL",

	"USER_UPDATE_CART_SUBSCRIBE_EMAIL",
	// val: boolean indicating whether or not to subscribe

	"SHOW_ALL_CHECKOUT_VALIDATION",
	// no params but uses current step in page

	"UPDATE_CART_SHOULD_COPY_SHIPPING",
	// - shouldCopy: boolean

	"CLEAR_CART_COUPON",

	"SUBSCRIPTION_CHANGE_CLEAR_COUPON",

	"USE_PLATFORM_ACCOUNT",
	// Use platform account for Parent Account during checkout
	// For users that aren't already BA users.

	"RETRY_SAVE_CART",
	//Retries the saving of the cart to the backend if no successfull saves have happened since the last failed save

	"BEGIN_EMAIL_SIGN_UP",
	// - email: string

	"CANCEL_PAYPAL",
	// no fields; just unsets onPaypalFlow

	"SET_PAYPAL_MODAL_DATA",
	// - paymentID
	// - payerID
	// - shippingVals: same as vals in UPDATE_CART_FORMDATA with section "shipping"
	// - contactVals: same as vals in UPDATE_CART_FORMDATA with section "contact"

	"SET_CAPTCHA_RESPONSE",
	// captchaResponse: the user's captcha answer, as obtained by getValue()

	"SET_CAPTCHA_UNANSWERED",

	"SHOW_OFFICE_MESSAGE",
	// - messageType = ""
	// - extraInfo = {}

	"SUPPRESS_BROWSER_WARNINGS",
	// Store value in local storage to suppress future browser warnings.

	// Library actions

	"LIBRARY_INITIAL",

	"UPDATE_LIBRARY_PAGES",
	// - chapterID
	// - readPageNumber
	// - newPageNumber
	// - timeOnOldPage

	"TOGGLE_TOP_BAR",
	// - isOpen: true/false

	"RETRY_UPDATE_LIBRARY_CHAPTER",

	//
	// Theater actions
	//
	"THEATER_INITIAL",
	"RETRY_UPDATE_VIDEO",
	"CLOSE_MODAL_IN_THEATER",
	"VIDEO_PLAY_PAUSE",
	// isPlaying: boolean

	"LOAD_DEMO_THEATER_SET",
	// - blockID
	"LOAD_DEMO_THEATER_CHAPTER",
	// - gradeNumber
	// - chapterIndex
	"LOAD_DEMO_THEATER_CHAPTERS",
	// no params

	"VIDEO_FINISHED",
	// no params

	"UPDATE_VIDEO_POSITION",
	// videoSetID: number,
	// videoIndex: number
	// blockIndex, chapterID: number - used to update theater chapters
	// position: video position (0-1)

	//
	// Lab actions
	//
	"LAB_INITIAL",

	"REPLAY_LAB_BLOCK",
	// - blockID

	//
	// BeastBuilder actions
	//
	"BEAST_INITIAL",

	"UPDATE_BEAST_PARTS",
	// - bps: new OpsBeastPartsState object

	"CLOSE_BEAST_GALLERY_MODAL",

	"CONFIRM_BEAST_SET_TO_PROFILE",
	// - avatarData = {userID, hash}

	"SAVE_TO_BEAST_GALLERY",
	// - avatarData: {userID, hash}
	// - setToProfile: also make this the profile photo

	//
	// Account page actions
	//

	"PARENT_INITIAL",
	// Dispatched as soon as parent bundle loads

	"SUBSCRIPTION_CHANGE_SET_USING_ACCOUNT_ADDRESS",
	// - value
	"SUBSCRIPTION_CHANGE_EDIT_SHIPPING",
	// - values
	"SUBSCRIPTION_CHANGE_SET_DISPLAY_NAME",
	// - value
	"SUBSCRIPTION_CHANGE_SET_PLAN_TYPE",
	// - value
	"SUBSCRIPTION_CHANGE_SET_BUNDLE_GRADES",
	// - value
	"SUBSCRIPTION_CHANGE_SET_BOOK_LEVEL_DEFERRED",
	// - value
	"SUBSCRIPTION_CHANGE_SET_AGREED_TO_BILLING",
	// - value
	"SUBSCRIPTION_CHANGE_SET_SHIPPING_NEW_DEFAULT",
	// - value

	"SUBSCRIPTION_CHANGE_SHOW_ALL_VALIDATION",
	// no params but uses current step in page

	"SUBSCRIPTION_CHANGE_GET_PRICES_RETRY",

	"PARENT_OFFICE_STUDENT_DATA_RELOAD",
	// no params

	//
	// School page actions
	//

	"SCHOOL_INITIAL",

	"SHOW_REPORT_PROBLEM_MODAL",
	// - resultID
	// - blockID
	// - userID
	// - problemIndex
	// - isTrophy
	// triggers the report problem to open

	// Shared

	"REPORT_INITIAL",

	//
	// Debug actions
	//

	"DEBUG_HIDE_DEV_WINDOWS",

	"DEBUG_RERENDER",

	"DEBUG_INCREMENT_TIME",

	"DEBUG_SAVE_TIME_NOW",

	"DEBUG_FINISH_WITH_STARS",

	//Finish a set with this many stars
	// - numStars: the number of stars you should receive

	"DEBUG_SUBMIT_TEST_PART_1",
	// Debug-only. Forces submission of Part 1 of a test with predetermined outcomes.
	// - passesForPart2: boolean, if true marks enough Part 1 correct to unlock Part 2; if false, not enough

	"DEBUG_SUBMIT_TEST_PART_2",
	// Debug-only. Forces submission of Part 2 of a test with predetermined outcomes.
	// - allCorrect: boolean, if true marks all Part 2 problems correct; if false, marks all incorrect

	"DEBUG_UNLOCK_CURRENT_BLOCK",
	// Debug-only. Unlocks the current block (test) without needing to earn stars.

	"DEBUG_UNLOCK_BLOCKS_IN_CURRENT_CHAPTER", //Unlock all blocks in the current chapter

	"TRIGGER_DEV_ENDPOINT", //Allows easier debugging of new endpoints without front-end hookup

	"POLICY_NOTIFICATION", //Used to engage modals for policy information on checkout

	"UPDATE_REDEEM_CODES_STUDENT_DATA", //Stores information about bulk code subscription redemption in the vault

	"ROSTERING_GO_TO_STEP",
	"ROSTERING_VALIDATE_CSVS_RESET",
	"ROSTERING_GENERATE_CSVS_RESET",
	"ROSTERING_SELECT_CSV",
	"ROSTERING_UPLOAD_SET_YEAR",
	"ROSTERING_RESET",

	"USER_DISMISSED_NOTIFICATION_MODAL",
	"DISMISS_ASSIGNED_BLOCK_MODAL",

	// Chapter Path
	"UPDATE_CHAPTER_PATH_AVATAR",
	"CLEAR_CHAPTER_PATH_ANIMATIONS",

	// Student Primary registration
	"STUDENT_PRIMARY_SETUP_GO_TO_STEP",

	"FORCE_LOAD_USER_PENDING",
] as const;

const API_ACTION_TYPES = [
	"UPDATE_TEMP_PASSWORD",
	"PASSWORD_RESET",
	"LOGOUT_USER",
	"ACCEPT_PRIVACY",
	"UPDATE_UNREGISTERED_USER",
	"UPDATE_USER",
	"IMITATE_STUDENT",
	"UPDATE_PAGE_DATA",
	"UPDATE_ACTIVITY_TIMES",
	"SEND_BUG_REPORT",
	"LOAD_USER",
	"LOAD_CHAPTER",
	"BLOCK_HISTORY",
	"PLAY_BLOCK",
	"UPDATE_RESULT",
	"QUIT_TEST_BLOCK",
	"LOAD_LIBRARY_CHAPTERS",
	"LOAD_LIBRARY_PAGES",
	"UPDATE_LIBRARY_CHAPTER_DATA",
	"CHECK_USER_EXISTS",
	"LOAD_USER_PLATFORM_BASICS",
	"LOAD_USER_PLATFORM_PLACEMENT",
	"STUDENT_ONBOARDING_PLACEMENT_COMPLETE",
	// Lab
	"LOAD_LAB_TYPE",
	"LOAD_ALL_LAB_TYPES",
	"PLAY_LAB_BLOCK",
	// Book Test
	"PLAY_BOOK_TEST_BLOCK",
	// Theater
	"UPDATE_VIDEO_DATA",
	"LOAD_THEATER_CHAPTER",
	"LOAD_THEATER_SET",
	// Parent/teacher locking
	"LOAD_LOCKS",
	"SET_LOCK_OVERRIDE",
	"SET_STUDENT_BEASTBUILDER_LOCK_OVERRIDE",
	"SET_CLASS_BEASTBUILDER_LOCK_OVERRIDE",
	"UNLOCK_LAB_ITEM_BEFORE_LAB_UNLOCKED",
	"SET_STUDENT_LEADERBOARDS_LOCK_OVERRIDE",
	// Office page
	"SUBMIT_CONTACT_FORM",
	"EMAIL_SIGN_UP",
	"SIGN_UP_ADDITIONAL_EMAIL_RECIPIENTS",
	"EMAIL_CONFIRMATION", //For new accounts
	"SAVE_CART",
	"START_PAYPAL",
	"GET_COUPON",
	"PREPARE_ORDER",
	"VERIFY_NEW_ACCOUNT",
	"PLACE_ORDER",
	"RESEND_CHECKOUT_EMAILS",
	"LOAD_HEAR_ABOUT_BA_SURVEY_STATUS",
	"SUBMIT_HEAR_ABOUT_BA_SURVEY",
	"LOCAL_ACADEMY",
	"ACCOUNT_PASSWORD_SETUP",
	"VERIFY_REDEEM_CODES",
	"REDEEM_SUBSCRIPTION_CODES",
	// Parent students page
	"GET_RANDOM_USERNAMES_FOR_PARENT",
	"GET_UNAVAILABLE_USERNAME_COMBINATIONS",
	"PARENT_UPDATE_UNREGISTERED_USER",
	"STUDENT_PRIMARY_SETUP_ADVANCE_STEP",
	"STUDENT_PRIMARY_SETUP_GENERATE_USERNAME",
	// Parent account page
	"LOAD_PARENT_ACCOUNT",
	"SAVE_PARENT_FORM",
	"DELETE_PARENT_CREDIT_CARD",
	"SAVE_PARENT_STUDENT_INFO",
	"SAVE_PARENT_PASSWORD",
	"SAVE_PARENT_NAME",
	"PARENT_SAVE_STUDENT_PASSWORD",
	"SAVE_PARENT_SUBSCRIPTION",
	"SUBSCRIPTION_VERIFY_SHIPPING",
	"SUBSCRIPTION_CHANGE_GET_PRICES",
	"SUBSCRIPTION_CHANGE_GET_COUPON",
	"SUBSCRIPTION_CHANGE_GET_SWITCH_TYPE_DATA",
	"FINISH_SUBSCRIPTION_CHANGE",
	"FINISH_SUBSCRIPTION_CANCEL",
	"LOAD_BOOK_DEFERRALS",
	"LOAD_DEFERRAL_PLACEMENT",
	"RESOLVE_BOOK_DEFERRAL",
	"LOAD_PARENT_UPCOMING_PAYMENTS",
	"LOAD_PARENT_MORE_PAST_PAYMENTS",
	"SUBMIT_CANCEL_REASON",
	"EMAIL_RECEIPT",
	// BA Demo
	"DEMO_EMAIL_SIGN_UP",
	// School pages
	"LOAD_REPORT_CLASSES_SLOT",
	"LOAD_REPORT_STUDENTS_SLOT",
	"LOAD_REPORT_STUDENTS_PRINT_SLOT",
	"LOAD_REPORT_GRADE_CHAPTER_SLOT",
	"LOAD_REPORT_CHAPTER_BLOCK_SLOT",
	"LOAD_REPORT_BLOCK_RESULTS_SLOT",
	"LOAD_REPORT_BOOK_TEST_RESULTS_SLOT",
	"LOAD_REPORT_LAB_TYPES_SLOT",
	"LOAD_REPORT_LAB_BLOCK_RESULTS_SLOT",
	"LOAD_CHAPTER_BLOCKS_SLOT",
	"LOAD_TYPE_LAB_BLOCKS_SLOT",
	"LOAD_SCHOOL_ENTITIES_SLOT",
	"LOAD_SCHOOL_ACCOUNTS",
	"LOAD_SCHOOL_ACCOUNTS_STUDENTS",
	"GENERATE_SCHOOL_USERNAME",
	"LOAD_SINGLE_CLASS",
	"REPORT_UNLOCK_BOOK_TEST",

	"UPDATE_SCHOOL_ACCOUNTS_SCOPE",
	"CREATE_SCHOOL_ACCOUNTS_SCOPE",
	"UPDATE_SCHOOL_CLASS_SETTINGS",
	"SET_ACTIVE_SCHOOL_ACCOUNTS_SCOPE",

	"UPDATE_SCHOOL_STAFF_ROLE",
	"UPDATE_SCHOOL_STUDENT_CLASS",
	"SET_ACTIVE_SCHOOL_ACCOUNTS_USER",

	"LOAD_REPORT_RESULT_SLOT",

	"ROSTERING_VALIDATE_CSVS",
	"ROSTERING_GENERATE_CSVS",
	"ROSTERING_PROCESS_CSVS",
	"POST_ROSTER_PROCESSING_ACCOUNT_RELOAD",
	"POST_ROSTER_PROCESSING_ACCOUNT_STUDENTS_RELOAD",

	"ADD_SEATS",

	//Beastbuilder
	"SAVE_BEAST",
	"FINISH_BEAST",
	"SET_AVATAR_BEAST",
	"LOAD_STUDENT_BEAST",
	"LOAD_BEAST_INVENTORY",
	"DELETE_GALLERY_BEAST",

	// Play student tutorial block
	"PLAY_STUDENT_TUTORIAL_BLOCK",
	"STUDENT_TUTORIAL_GET_VIDEO",
	"STUDENT_TUTORIAL_GET_BOOK_PAGE",
	// For use with the set progress buttons
	"STUDENT_TUTORIAL_UPDATE_PROGRESS",

	// CMS Info Pages
	"LOAD_CMS_INFO_PAGE",

	// Marketing
	"LOG_MARKETING_EVENTS",
	"LOG_MARKETING_SOURCE",

	// ClassWallet
	"CLASS_WALLET_SUBMIT",
	"CLASS_WALLET_GET_CUSTOMER_INFO",

	// Old slots
	"LOAD_PROFILE_SLOT",
	"LOAD_PROFILE_ACTIVITY_SLOT",
	"LOAD_PROFILE_ACTIVITY_DAY_SLOT",
	"LOAD_HOMEWORK_SLOT",
	"LOAD_TEACHER_CLASSES_SLOT",
	"LOAD_TEACHER_CLASS_DATA_SLOT",
	"LOAD_TEACHER_CLASS_DATA_CHAPTERS_SLOT",
	"LOAD_PARENT_DATA_SLOT",
	"LOAD_PARENT_DATA_CHAPTERS_SLOT",
	"LOAD_CONTENT_REPORT_SLOT",
	// Debug
	"DEV_ENDPOINT",
	"UNIMITATE",
	"DEBUG_IMPORT_TRAINER_DATA_FOR_USER",
	"DEBUG_IMPORT_TRAINER_DATA_FOR_CLASS",

	// Fetches top N users in leaderboards
	"FETCH_LEADERBOARDS_RANKINGS",
	// - newXPTotal: sets student XP to new total in debug environment
	"DEBUG_SET_XP",
	"DEBUG_RESET_LEVEL_NOTIFICATION",

	"LOAD_ASSIGNED_BLOCKS_FOR_CLASS",
	"ASSIGN_BLOCK_FOR_CLASS",

	"ADD_ONE_OFF_REWARD",
	"SET_ONE_OFF_REWARD_NOTIFICATION_SHOWN",

	"UPDATE_LAB_LOCK_SCHEDULE",
	"LOAD_LAB_LOCK_SCHEDULE",

	// Dev endpoints
	"DEV_ADD_NEW_STUDENT",
] as const;

export const VALUE_PREFIX = "_@CTION_";

export const REQUEST_PREFIX = "_@REQUEST_";
export const SUCCESS_PREFIX = "_@SUCCESS_";
export const FAIL_PREFIX = "_@FAIL_";

export const REQUEST_SUFFIX = "_REQUEST";
export const SUCCESS_SUFFIX = "_SUCCESS";
export const FAIL_SUFFIX = "_FAIL";

// Helper types for API action patterns
export type ApiActionType = typeof API_ACTION_TYPES[number];
// Template literal types for API action patterns
export type ApiRequestAction = `${ApiActionType}${typeof REQUEST_SUFFIX}`;
export type ApiSuccessAction = `${ApiActionType}${typeof SUCCESS_SUFFIX}`;
export type ApiFailAction = `${ApiActionType}${typeof FAIL_SUFFIX}`;

export type ApiAction = ApiRequestAction | ApiSuccessAction | ApiFailAction;

export type ApiRequestValue = `${typeof REQUEST_PREFIX}${ApiActionType}`;
export type ApiSuccessValue = `${typeof SUCCESS_PREFIX}${ApiActionType}`;
export type ApiFailValue = `${typeof FAIL_PREFIX}${ApiActionType}`;
export type ApiActionValue = ApiRequestValue | ApiSuccessValue | ApiFailValue;

type RegularAction = typeof ACTION_TYPES[number];
export type RegularActionValue = `${typeof VALUE_PREFIX}${RegularAction}`;

export type Action = RegularAction | ApiAction;
export type ActionValue = RegularActionValue | ApiActionValue;

// Helper function to map the action types to the corresponding string values
const getActions : () => Record<Action, RegularActionValue> = () => {
	const actions = ACTION_TYPES.map(type => [type, VALUE_PREFIX + type]);
	return Object.fromEntries(actions);
};

// Helper function to map the three API actions corresponding to each API action
// type to a string value
const getApiActions : () => Record<ApiAction, ApiActionValue> = () => {
	const actions = API_ACTION_TYPES.flatMap(type => [
		[type + REQUEST_SUFFIX, REQUEST_PREFIX + type],
		[type + SUCCESS_SUFFIX, SUCCESS_PREFIX + type],
		[type + FAIL_SUFFIX, FAIL_PREFIX + type],
	]);
	return Object.fromEntries(actions);
};

// Map of all action types to their corresponding string values
export const AT : Record<Action, ActionValue> = {
	...getActions(),
	...getApiActions(),
};
